export enum EnMedicationPeriod {
    SOS,
    stop,
    timeInterval
}
